import { useDispatch, useSelector } from 'react-redux';
import { SEARCH_WORD_SET } from '../app/redux/actions/search';

export const useHighlightText = (text = '') => {
  const searchWord = useSelector((state) => state.search.search_word);

  if (!searchWord) return text;

  // use regex to find all words (case UNsensitive)
  const regex = new RegExp(`(${searchWord})`, 'gi');

  // split text and replace words with span.highlight
  const parts = text.split(regex);
  const joinedParts = parts.map((part, index) =>
    regex.test(part)
      ? `<span key={${index}} class="highlight">${part}</span>`
      : part
  );

  return joinedParts.join('');
};

export const useResetSearchWord = () => {
  const dispatch = useDispatch();
  return () => dispatch({ type: SEARCH_WORD_SET, response: '' });
};
